// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFieldWithPrefix__content-a3134e {
  display: flex;
  flex-direction: row;
  position: relative;
  height: 52px;
  background-color: var(--base-20);
  border-radius: 12px;
  box-sizing: border-box;
  padding-bottom: 2px;
  overflow: hidden;
}

.TextFieldWithPrefix__content-a3134e:focus-within > .TextFieldWithPrefix__label-b20465,
.TextFieldWithPrefix__content-a3134e:focus-within > .TextFieldWithPrefix__input-b6d2bb {
  border-bottom-color: var(--brand-secondary-40);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__success-b7135a > .TextFieldWithPrefix__label-b20465,
.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__success-b7135a > .TextFieldWithPrefix__input-b6d2bb {
  border-bottom-color: var(--success-30);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__success-b7135a + .TextFieldWithPrefix__helper-text-cfd089 {
  color: var(--success-30);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__error-c09f18 > .TextFieldWithPrefix__label-b20465,
.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__error-c09f18 > .TextFieldWithPrefix__input-b6d2bb {
  border-bottom-color: var(--danger-40);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__error-c09f18 + .TextFieldWithPrefix__helper-text-cfd089 {
  color: var(--danger-40);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__disabled-b05c03 > .TextFieldWithPrefix__label-b20465 {
  color: var(--base-50);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__disabled-b05c03 > .TextFieldWithPrefix__input-b6d2bb {
  color: var(--base-50);
}

.TextFieldWithPrefix__content-a3134e.TextFieldWithPrefix__disabled-b05c03 > .TextFieldWithPrefix__input-b6d2bb::placeholder {
  color: var(--base-50);
}

.TextFieldWithPrefix__label-b20465 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-120);
  border-bottom: 2px solid transparent;
  display: flex;
  align-items: center;
  padding-inline-start: 12px;
}

.TextFieldWithPrefix__input-b6d2bb {
  flex: 1;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  border-bottom: 2px solid transparent;
}

.TextFieldWithPrefix__helper-text-cfd089 {
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--base-80);
  margin-top: 4px;
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/TextFieldWithPrefix/TextFieldWithPrefix.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,8CAAA;AACF;;AAEA;;EAEE,sCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;;EAEE,qCAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;AACF;;AAEA;EACE,OAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,oCAAA;AACF;;AAEA;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  height: 52px;\n  background-color: var(--base-20);\n  border-radius: 12px;\n  box-sizing: border-box;\n  padding-bottom: 2px;\n  overflow: hidden;\n}\n\n.content:focus-within > .label,\n.content:focus-within > .input {\n  border-bottom-color: var(--brand-secondary-40);\n}\n\n.content.success > .label,\n.content.success > .input {\n  border-bottom-color: var(--success-30);\n}\n\n.content.success + .helper-text {\n  color: var(--success-30);\n}\n\n.content.error > .label,\n.content.error > .input {\n  border-bottom-color: var(--danger-40);\n}\n\n.content.error + .helper-text {\n  color: var(--danger-40);\n}\n\n.content.disabled > .label {\n  color: var(--base-50);\n}\n\n.content.disabled > .input {\n  color: var(--base-50);\n}\n\n.content.disabled > .input::placeholder {\n  color: var(--base-50);\n}\n\n.label {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-120);\n  border-bottom: 2px solid transparent;\n  display: flex;\n  align-items: center;\n  padding-inline-start: 12px;\n}\n\n.input {\n  flex: 1;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  border-bottom: 2px solid transparent;\n}\n\n.helper-text {\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--base-80);\n  margin-top: 4px;\n  padding: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TextFieldWithPrefix__content-a3134e`,
	"label": `TextFieldWithPrefix__label-b20465`,
	"input": `TextFieldWithPrefix__input-b6d2bb`,
	"success": `TextFieldWithPrefix__success-b7135a`,
	"helper-text": `TextFieldWithPrefix__helper-text-cfd089`,
	"helperText": `TextFieldWithPrefix__helper-text-cfd089`,
	"error": `TextFieldWithPrefix__error-c09f18`,
	"disabled": `TextFieldWithPrefix__disabled-b05c03`
};
module.exports = ___CSS_LOADER_EXPORT___;
